"use strict";

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ChevronRight = function ChevronRight(props) {
  var _props$width = props.width,
      width = _props$width === void 0 ? 20 : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? 20 : _props$height,
      _props$color = props.color,
      color = _props$color === void 0 ? "#000" : _props$color;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 7 12",
    scale: width / 7,
    width: width,
    height: height,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.105 9.309l5.168-5.204a.49.49 0 0 1 .3-.105.49.49 0 0 1 .298.105l.703.704c.07.093.106.199.106.316a.38.38 0 0 1-.106.281L9.391 9.625l4.183 4.219a.38.38 0 0 1 .106.281.514.514 0 0 1-.106.316l-.703.668a.42.42 0 0 1-.299.141.49.49 0 0 1-.299-.105L7.105 9.906A.38.38 0 0 1 7 9.625c0-.117.035-.223.105-.316z",
    id: "chevronRight"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-7 -4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: color,
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 20.68 0)",
    xlinkHref: "#chevronRight"
  })));
};

var _default = ChevronRight;
exports["default"] = _default;
module.exports = exports["default"];